import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de réduction - Calculer le prix après remise";
const DESCRIPTION =
  "Calculatrice de réduction - Calculer le prix après remise. Outil financier en francais pour obtenir un calcul rapide, clair et exploitable pour vos decisions de budget, prix et rentabilite.";
const KEYWORDS =
  "réduction prix après remise, calculatrice financiere, budget, rentabilite, marge, gestion des couts, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/discount-calculator/";

function DiscountCalculator() {
  const [originalPrice, setOriginalPrice] = useState("");
  const [discountPercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState(null);
  const [finalPrice, setFinalPrice] = useState(null);
  const [error, setError] = useState("");

  const calculateDiscount = () => {
    try {
      if (!originalPrice || !discountPercent || originalPrice === "0" || discountPercent === "0") {
        setError("Veuillez entrer un prix et un pourcentage valides");
        return;
      }
      const price = parseFloat(originalPrice);
      const percent = parseFloat(discountPercent);
      
      if (percent < 0 || percent > 100) {
        setError("Le pourcentage doit être entre 0 et 100");
        return;
      }
      
      const discount = price * (percent / 100);
      const final = price - discount;
      
      setDiscountAmount(discount);
      setFinalPrice(final);
      setError("");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleReset = () => {
    setOriginalPrice("");
    setDiscountPercent("");
    setDiscountAmount(null);
    setFinalPrice(null);
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3">
            <div className="row">
              <div>
                <p>
                  Cette <strong>calculatrice de réduction</strong> vous permet de calculer rapidement 
                  le prix après remise. Que vous faites vos courses, achetez en ligne ou planifiez 
                  un budget, cette calculatrice vous montre exactement combien vous économisez avec 
                  chaque code promo ou offre spéciale.
                </p>
                <p>
                  Par exemple, si un produit coûte 100 € avec une réduction de 20%, vous économisez 
                  20 € et ne payez que 80 €. Notre calculatrice effectue ce calcul instantanément.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px", margin: 0 }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center mb-3">
                    <label htmlFor="price" style={{ marginRight: "10px", minWidth: "150px" }}>Prix original:</label>
                    <input
                      id="price"
                      type="number"
                      value={originalPrice}
                      onChange={(e) => setOriginalPrice(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                      placeholder="Exemple: 100"
                      step="0.01"
                      min="0"
                    />
                  </div>
                  <div className="form-group d-flex align-items-center mb-3">
                    <label htmlFor="discount" style={{ marginRight: "10px", minWidth: "150px" }}>% de réduction:</label>
                    <input
                      id="discount"
                      type="number"
                      value={discountPercent}
                      onChange={(e) => setDiscountPercent(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                      placeholder="Exemple: 20"
                      step="0.01"
                      min="0"
                      max="100"
                    />
                  </div>
                  <br />
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "16px" }}
                      onClick={calculateDiscount}
                    >
                      Calculer
                    </button>
                    <button
                      className="btn btn-secondary"
                      style={{ fontSize: "16px" }}
                      onClick={handleReset}
                    >
                      Réinitialiser
                    </button>
                  </div>
                </div>
                {error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Erreur: {error}</p>
                ) : (
                  discountAmount !== null && finalPrice !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <table style={{ width: "100%", textAlign: "center" }}>
                        <tbody>
                          <tr>
                            <td><strong>Montant économisé:</strong></td>
                            <td><strong style={{ fontSize: "18px" }}>{discountAmount.toFixed(2)} €</strong></td>
                          </tr>
                          <tr>
                            <td><strong>Prix final:</strong></td>
                            <td><strong style={{ fontSize: "18px", color: "#d1f2eb" }}>{finalPrice.toFixed(2)} €</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>Qu'est-ce qu'une remise ou réduction?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Une <strong>réduction</strong> (aussi appelée <strong>remise</strong> ou <strong>rabais</strong>) 
                  est une diminution du prix d'un produit ou d'un service. Elle est généralement exprimée en 
                  <strong> pourcentage</strong> (par exemple 20%) ou en montant fixe (par exemple 5 €).
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  Les réductions sont utilisées par les commerçants pour:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Attirer de nouveaux clients</li>
                  <li>Écouler les anciens stocks</li>
                  <li>Récompenser la fidélité des clients</li>
                  <li>Augmenter les volumes de ventes</li>
                  <li>Faire face à la concurrence</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Types de réductions et offres spéciales</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>1. Réductions en pourcentage</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Les plus courantes. Un article à 100 € avec 30% de réduction = 70 €.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>2. Réductions en montant fixe</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Un montant spécifique est déduit. Par exemple, 15 € de réduction sur tout achat 
                  de plus de 50 €.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>3. Réductions progressives</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Plus vous achetez, plus la remise est importante. Par exemple: 10% pour 2 articles, 
                  20% pour 3+ articles.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>4. Codes promo</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Des codes spéciaux donnent des réductions lors du paiement en ligne.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>5. Offres temporelles</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Les "Black Friday", "Soldes d'été" ou "Clearance" proposent des réductions temporaires.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Comment calculer une réduction</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Calculer le prix après réduction est très simple avec cette formule:
                </p>
                <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                  <strong>Formule:</strong>
                  <br />
                  <code style={{ fontSize: "16px" }}>
                    Montant de réduction = Prix original × (Pourcentage ÷ 100)<br />
                    Prix final = Prix original - Montant de réduction
                  </code>
                </div>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Exemple pratique:</h3>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>Données:</strong>
                  <ul style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <li>Prix original: 150 €</li>
                    <li>Réduction: 25%</li>
                  </ul>
                  <strong>Calcul:</strong>
                  <br />
                  150 € × (25 ÷ 100) = <strong>37,50 € de réduction</strong>
                  <br />
                  150 € - 37,50 € = <strong>112,50 € (prix final)</strong>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Conseils pour trouver les meilleures réductions</strong>
              </div>
              <div className="info-section-body">
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Comparer les prix:</strong> Même après réduction, vérifiez que c'est le 
                    meilleur prix disponible ailleurs.
                  </li>
                  <li>
                    <strong>S'inscrire aux newsletters:</strong> Les magasins proposent souvent des 
                    codes promo exclusifs aux abonnés.
                  </li>
                  <li>
                    <strong>Attendre les périodes commerciales:</strong> Les réductions maximales 
                    arrivent pendant les soldes ou événements spéciaux.
                  </li>
                  <li>
                    <strong>Combinaisons de réductions:</strong> Certains magasins permettent d'empiler 
                    les coupons pour des économies plus importantes.
                  </li>
                  <li>
                    <strong>Cumuler les points de fidélité:</strong> Les programmes de fidélité offrent 
                    des réductions additionnelles.
                  </li>
                  <li>
                    <strong>Vérifier les dates d'expiration:</strong> Les codes promo et offres ont 
                    souvent une date limite.
                  </li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Questions fréquemment posées</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Q: Comment dois-je interpréter "50% de réduction"?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Cela signifie que vous payez la moitié du prix original. Un article de 100 € avec 
                  50% de réduction coûte 50 €.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Q: Deux réductions peuvent-elles être appliquées ensemble?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Cela dépend de la politique du magasin. Certains permettent de cumuler les réductions (appliquer 
                  la deuxième sur le prix déjà réduit), d'autres non. Vérifiez toujours les conditions.
                </p>
                <h3 style={{ fontSize: "16px", marginTop: "15px" }}>Q: Une réduction de 100% signifie-t-elle que c'est gratuit?</h3>
                <p style={{ lineHeight: "1.8" }}>
                  Oui, si vous bénéficiez d'une réduction de 100%, vous payez 0 €. C'est rare et généralement 
                  réservé aux offres spéciales ou erreurs de prix.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiscountCalculator;
